import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '../components/App';

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
